import script from "./ParisGuide.vue?vue&type=script&lang=ts&setup=true"
export * from "./ParisGuide.vue?vue&type=script&lang=ts&setup=true"

import "./ParisGuide.vue?vue&type=style&index=0&id=2b9cf2f7&scoped=true&lang=css"

import exportComponent from "/Users/jnshul/Documents/tagluffa_i_vue3/main_page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b9cf2f7"]])

export default __exports__